"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWeekDay = void 0;
const react_1 = require("react");
const models_1 = require("../../models");
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const useWeekDay = (availability, currDay) => {
    (0, react_1.useDebugValue)(availability);
    return (0, react_1.useMemo)(() => {
        var _a;
        if (currDay) {
            return currDay;
        }
        const tzone = (_a = availability === null || availability === void 0 ? void 0 : availability.timezone) !== null && _a !== void 0 ? _a : models_1.Timezone.AmericaToronto;
        return ({ n: moment_timezone_1.default.tz(tzone).isoWeekday(), tz: tzone });
    }, [availability]);
};
exports.useWeekDay = useWeekDay;
